function initSeriesBanner() {
    $('.series__banner .banner__close').click(function() {
        Cookies.set('hide_series_banner', true, { domain: global_tokyvideo_cookie_lang_domain, path: '/', sameSite: 'none', secure: true });
    });

    if (typeof Cookies.get('hide_series_banner') == "undefined") {
        $('.series__banner').css('display', 'flex');
    }
}
